import { useFetchUserCircles } from "@platform/hooks/useFetchUserCircles";
import { SupportContainer } from "../../support/components/Support/SupportContainer";
import { SupportRecommendedArticlesContainer } from "../../support/components/SupportRecommendedArticles/SupportRecommendedArticlesContainer";
import { usePlatform } from "@platform/PlatformContext";

export function DashboardSupportHomePage() {
  const { user } = usePlatform();

  const isUserLoggedIn = !!user;

  // Load user circles data for chat visibility logic
  useFetchUserCircles({ isEnabled: isUserLoggedIn });

  return (
    <SupportContainer
      title="Support Center"
      description="Browse our categories or use the search to find help on specific topics."
    >
      <SupportRecommendedArticlesContainer />
    </SupportContainer>
  );
}

export default DashboardSupportHomePage;
